import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Section, StatusBadge } from "@/components/common/kit";
import DataTable from "@/components/common/DataTable";
import RemoteTable from "@/components/common/RemoteTable";
import { DateRangeFilter, SalesmanSelect, useRange } from "@/components/common/Filters";
import { OVERVIEW_COLS } from "./Dashboard";

export const CLOSURE_COLS = [
  { key: "date", label: "Date", type: "date" }, { key: "salesman_name", label: "Salesman" },
  { key: "packs", label: "Packs Sold", type: "int", render: (r) => r.totals?.packs_sold ?? "—", exportValue: (r) => r.totals?.packs_sold },
  { key: "value", label: "Sales ₹", type: "money", render: (r) => (r.totals ? `₹${r.totals.sales_value.toLocaleString("en-IN")}` : "—"), exportValue: (r) => r.totals?.sales_value },
  { key: "cash", label: "Cash", type: "money" }, { key: "gpay", label: "GPay", type: "money" },
  { key: "receivable", label: "Receivable", type: "money" },
  { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
  { key: "version", label: "Submissions", type: "int" }, { key: "submitted_at", label: "Submitted", type: "datetime" },
];

export default function Closures() {
  const { bizDate } = useAuth();
  const nav = useNavigate();
  const [date, setDate] = useState(bizDate);
  const [range, setRange] = useRange("month");
  const [sid, setSid] = useState("");
  const [status, setStatus] = useState("all");
  const { data } = useFetch("/dashboard/overview", { date });
  return (
    <div className="space-y-6">
      <PageHeader title="Daily Closures" subtitle="Review submitted days, open days and reopen when corrections are needed" />
      <Section title="Day status by salesman" actions={<Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="h-9 w-44" data-testid="closures-date" />}>
        <DataTable columns={OVERVIEW_COLS} rows={data?.rows || []} onRowClick={(r) => nav(`/admin/day/${r.salesman_id}/${date}`)} testid="closures-day-table" title={`Closures ${date}`} exportable />
      </Section>
      <Section title="Closure history">
        <div className="mb-3 flex flex-wrap gap-2">
          <DateRangeFilter value={range} onChange={setRange} />
          <SalesmanSelect value={sid} onChange={setSid} allowAll />
          <Select value={status} onValueChange={setStatus}>
            <SelectTrigger className="h-9 w-40" data-testid="closures-status-filter"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="all">All statuses</SelectItem><SelectItem value="CLOSED">Closed</SelectItem><SelectItem value="REOPENED">Reopened</SelectItem><SelectItem value="OPEN">Open (draft)</SelectItem></SelectContent>
          </Select>
        </div>
        <RemoteTable url="/closures" params={{ salesman_id: sid || undefined, status: status === "all" ? undefined : status, date_from: range.from, date_to: range.to }}
          columns={CLOSURE_COLS} onRowClick={(r) => nav(`/admin/day/${r.salesman_id}/${r.date}`)} title="Closure history" exportable searchable={false} testid="closures-history-table" />
      </Section>
    </div>
  );
}
